import { createStore } from 'vuex'
import user from './modules/user'

export default createStore({
  modules: {
    user
  },
  getters: {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    isLoggedIn: state => !!state.user.token
  },
  strict: process.env.NODE_ENV !== 'production'
})
